"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importDefault(require("react"));
const helpers_1 = require("../../helpers");
const MainNavigatorContext_1 = require("../MainNavigatorContext");
/**
 * Navigation
 * This serves as an entry point where BlueBase passes routes and navigation
 * configs to this component.
 */
const Navigation = (props) => {
    const { Router, navigator: rawNavigator } = props, rest = tslib_1.__rest(props, ["Router", "navigator"]);
    const Navigator = core_1.useComponent('Navigator');
    const [routerProps] = core_1.useConfig('plugin.react-router.router-props');
    const navigatorObject = helpers_1.preparePaths(rawNavigator);
    return (react_1.default.createElement(MainNavigatorContext_1.MainNavigatorContext.Provider, { value: { navigator: navigatorObject, rawNavigator } },
        react_1.default.createElement(Router, Object.assign({}, rest, routerProps),
            react_1.default.createElement(Navigator, Object.assign({}, navigatorObject, { standalone: false })))));
};
exports.Navigation = Navigation;
